/**
 * Whether this tab may write the shared local message store. Every tab runs `chatEffect`
 * on the frames the leader forwards (tab-link.ts) to keep its own room state, but they
 * share one IndexedDB, so only the leader writes it. On by default: a tab with nobody to
 * coordinate with is its own leader.
 */
let writer = true;

export const setMessageStoreWriter = (on: boolean) => {
  writer = on;
};

export const isMessageStoreWriter = () => writer;
